import React, { useState } from 'react';
import NoStockForm from './NoStockForm';
import s from "./Card.module.css";
import { useNavigate } from "react-router-dom";
import { CallToAction } from '../CallToAction/CallToAction';
import { toastSuccess, toastError } from "../../helpers/index";
import { useDispatch, connect } from 'react-redux';
import { updateCart } from '../../redux/actions';
import { capitalizeWords, formatNumber, correctEncoding } from '../../helpers/index';
import nolibro from "../../assets/nolibro.png";

function Card({ product, isSanteria }) {
    const [noStockModal, setNoStockModal] = useState(false);

    const productName = capitalizeWords(correctEncoding(product.titulo, isSanteria));
    const productImage = product.imagen_odoo ? `data:image/png;base64,${product.imagen_odoo}` : (isSanteria && product.imagen) ? `${process.env.REACT_APP_IMG_API}${product.imagen}` : nolibro;

    // Tarjeta de producto

    const Navigate = useNavigate();
    const dispatch = useDispatch();

    const redirectDetail = () => {
        const titleSlug = product.titulo.replace(/\s+/g, '_');
        if (isSanteria) {
            Navigate(`/Detalle/Objetos/${product.id_santeria}`);
        } else {
            Navigate(`/Detalle/Libro/${titleSlug}/${product.id_libro}`);
        }
    }

    const closeNoStockModal = () => {
        setNoStockModal(false);
    }

    const handleCart = function () {
        let productsCart = [];
    
        // Función para verificar si el stock es excedido
        const checkStock = (currentQuantity) => {
            return currentQuantity + 1 > product.stockMin;
        };
    
        if (localStorage.getItem("order")) {
            productsCart = JSON.parse(localStorage.getItem("order")); // Parsear directamente
    
            // Determinar el tipo de producto (Santería o Libro)
            const productKey = isSanteria ? "id_santeria" : "id_libro";
            const productId = isSanteria ? product.id_santeria : product.id_libro;
    
            // Buscar el producto en el carrito
            const existingProduct = productsCart.find(
                (p) => p[productKey] === productId
            );
    
            if (existingProduct) {
                // Verificar stock antes de agregar
                if (!isSanteria && checkStock(existingProduct.cant)) {
                    toastError("La cantidad supera el stock disponible.");
                    return; // Salir de la función si excede
                }
                existingProduct.cant += 1; // Actualizar cantidad
            } else {
                // Verificar stock para nuevo producto
                if (!isSanteria && 1 > product.stockMin) {
                    toastError("No hay stock disponible para este producto.");
                    return;
                }
                productsCart.push({ ...product, cant: 1 }); // Agregar nuevo
            }
    
            localStorage.setItem("order", JSON.stringify(productsCart));
        } else {
            // Verificar stock antes de crear el carrito
            if (1 > product.stockMin) {
                toastError("No hay stock disponible para este producto.");
                return;
            }
            productsCart.push({ ...product, cant: 1 });
            localStorage.setItem("order", JSON.stringify(productsCart));
        }
    
        toastSuccess("Producto agregado al carrito");
        dispatch(updateCart());
    };

    return (
        <>
            <div className={s.container}>
                <img 
                    alt={"Portada de " + productName} 
                    src={productImage}
                    onClick={redirectDetail} 
                />
                <div className={s.gap} />
                <div className={s.data}>
                    <p className={s.titulo} onClick={redirectDetail}>
                        {productName}
                    </p>
                    <div>
                        {
                            !isSanteria &&
                            <p className={s.autor}>{capitalizeWords(product.autores)}</p>
                        }

                        {
                            product.precio === product.preciodescuento && (product.preciodescuento != "0.00" && product.precio !== "0.00") &&
                            <p className={s.precio}>{formatNumber(product.precio)}</p>
                        }
                        {
                            product.precio !== product.preciodescuento && (product.preciodescuento != "0.00" && product.precio !== "0.00") &&
                            <div>
                                <p className={s.precioDescuento}>{formatNumber(product.precio)}</p>
                                <p className={s.nuevoPrecio}>{formatNumber(product.preciodescuento)}</p>
                            </div>
                        }
                    </div>
                </div>
                {
                    !isSanteria && product.stockMin <= 3 ?
                        <button className={s.noStockButton} onClick={() => setNoStockModal(true)}>
                            Notificarme cuando esté disponible
                        </button>
                        :
                        product.preciodescuento == "0.00" || product.precio == "0.00" ?
                            <CallToAction content="Agregar al Carrito" disabledStyle={true} />
                            :
                            <CallToAction content="Agregar al Carrito" onClick={() => { handleCart(); }} />
                }
            </div>

            <NoStockForm noStockModal={noStockModal} closeNoStockModal={closeNoStockModal} productCode={product.codigo} />
        </>
    )
}

export default connect(null, { updateCart })(Card);